import {
  SpaceBetween,
  Grid,
  FormField,
  Input,
} from "@cloudscape-design/components-themed";
import { memo } from "react";
import { LABELS, CONSTRAINT_TEXT } from "../constants";
import InfoField from "../../UI/InfoField";

interface EmailInputRowProps {
  ipid: string;
  email: string;
  error?: string;
  onChange: (ipid: string, value: string) => void;
}

/**
 * 入金口座情報照会・更新 精算額通知先 入力行
 */
export const EmailInputRow = memo((props: EmailInputRowProps) => {
  const { ipid, email, error, onChange } = props;

  return (
    <SpaceBetween direction="vertical" size="xxs">
      <Grid gridDefinition={[{ colspan: 3 }, { colspan: 9 }]}>
        <SpaceBetween direction="horizontal" size="xxl">
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"h4"}
            values={[LABELS.IPID]}
          />
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"p"}
            values={[ipid]}
          />
        </SpaceBetween>
        <SpaceBetween direction="horizontal" size="xxl">
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"h4"}
            values={[LABELS.EMAIL]}
          />
          <FormField
            errorText={error}
            constraintText={`${CONSTRAINT_TEXT.EMAIL}　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　`}
          >
            <Input
              value={email}
              onChange={({ detail }) => onChange(ipid, detail.value)}
            />
          </FormField>
        </SpaceBetween>
      </Grid>
    </SpaceBetween>
  );
});
